import React from "react";
import ReactSelect from "react-select";
import "./Select.css";

/**
 * Custom Select component that wraps react-select with the styling from DropDown component
 */
const Select = ({
  options,
  value,
  onChange,
  loading = false,
  placeholder,
  isSearchable = true,
  maxMenuHeight = 200,
  isDisabled = false,
  isClearable = true,
  classNamePrefix = "react-select",
  className = "",
  ...restProps
}) => {
  return (
    <div className={"analyticsDropdown" + (className ? ` ${className}` : "")} style={{ position: 'relative' }}>
      {placeholder && value && (
        <label className="select-floating-label" style={{
          position: 'absolute',
          top: -10,
          left: 10,
          background: '#fff',
          padding: '0 4px',
          fontSize: 12,
          color: '#888',
          zIndex: 2
        }}>{placeholder}</label>
      )}
      {options && options.length > 0 && !value && (
        <div className="options-count">{options.length}</div>
      )}
      <ReactSelect
        options={options}
        value={value}
        onChange={onChange}
        isDisabled={loading || isDisabled}
        isClearable={isClearable}
        className={`react-select-container ${className}`}
        classNamePrefix={classNamePrefix}
        placeholder={placeholder}
        isSearchable={isSearchable}
        maxMenuHeight={maxMenuHeight}
        {...restProps}
      />
    </div>
  );
};

export default Select;
